import { ORDER_STATUS_ICONS } from '@/modules/shared/constants/order-status-icons'

export const ORDER_STATUS = {
	AT: {
		...ORDER_STATUS_ICONS.MdCloudDone,
		label: 'Aguardando Transmissão',
		sigla: 'AT',
	},
	BL: {
		...ORDER_STATUS_ICONS.MdBlock,
		label: 'Bloqueado',
		sigla: 'BL',
	},
	CA: {
		...ORDER_STATUS_ICONS.MdLocalShipping,
		label: 'Carregado',
		sigla: 'CA',
	},
	CN: {
		...ORDER_STATUS_ICONS.MdCancel,
		label: 'Cancelado',
		sigla: 'CN',
	},
	LI: {
		...ORDER_STATUS_ICONS.MdCheckCircle,
		label: 'Liberado',
		sigla: 'LI',
	},
	LP: {
		...ORDER_STATUS_ICONS.MdCheckCirclePartially,
		label: 'Liberado Parcialmente',
		sigla: 'LP',
	},
	PE: {
		...ORDER_STATUS_ICONS.MdPending,
		label: 'Pendente',
		sigla: 'PE',
	},
	RA: {
		...ORDER_STATUS_ICONS.MdEditDocument,
		label: 'Rascunho',
		sigla: 'RA',
	},
	TR: {
		...ORDER_STATUS_ICONS.MdFactory,
		label: 'Transmitido',
		sigla: 'TR',
	},
	FT: {
		...ORDER_STATUS_ICONS.MdRequestQuote,
		label: 'Faturado',
		sigla: 'FT',
	},
}
